  (function () {
    function PanelCarousel(panel) {
      this.panel    = panel;
      this.track    = panel.querySelector('.cdi-home-products__track');
      this.items    = panel.querySelectorAll('.cdi-home-products__item');
      this.dots     = panel.querySelectorAll('.cdi-home-products__dot');
      this.prevBtn  = panel.querySelector('.cdi-home-products__arrow--prev');
      this.nextBtn  = panel.querySelector('.cdi-home-products__arrow--next');
      this.pageSize = parseInt(panel.getAttribute('data-page-size') || '3', 10);
      this.total    = parseInt(panel.getAttribute('data-total-items') || '0', 10);
      this.page     = 0;
      this.pages    = Math.ceil(this.total / this.pageSize);
      this.viewport = this.track;
      this._queued  = false;

      this._bind();
    }

    PanelCarousel.prototype._maxScroll = function () {
      return this.viewport.scrollWidth - this.viewport.clientWidth;
    };

    PanelCarousel.prototype._pageFromScroll = function () {
      var max  = this._maxScroll();
      var left = this.viewport.scrollLeft;
      var step = this.pageSize * this._cardWidth();
      if (max <= 1 || !step) return 0;
      if (left >= max - 1) return this.pages - 1;
      return Math.min(this.pages - 1, Math.round(left / step));
    };

    PanelCarousel.prototype._onScroll = function () {
      var self = this;
      if (this._queued) return;
      this._queued = true;
      requestAnimationFrame(function () {
        self._queued = false;
        self.page = self._pageFromScroll();
        self._syncUI();
      });
    };

    PanelCarousel.prototype._cardWidth = function () {
      var first = this.items[0];
      if (!first) return 0;
      return first.offsetWidth + 16;
    };

    PanelCarousel.prototype.goTo = function (page) {
      if (page < 0) page = 0;
      if (page >= this.pages) page = this.pages - 1;

      var target = Math.min(page * this.pageSize * this._cardWidth(), this._maxScroll());
      this.viewport.scrollTo({ left: target, behavior: 'smooth' });
    };

    PanelCarousel.prototype._syncUI = function () {
      var self = this;
      this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === self.page);
        dot.setAttribute('aria-disabled', i === self.page ? 'true' : 'false');
      });
      if (this.prevBtn) this.prevBtn.disabled = this.page === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.page >= this.pages - 1;
    };

    PanelCarousel.prototype.reset = function () {
      this.page = 0;
      this.viewport.scrollTo({ left: 0, behavior: 'instant' });
      this._syncUI();
    };

    PanelCarousel.prototype._bind = function () {
      var self = this;
      this.viewport.addEventListener('scroll', function () { self._onScroll(); }, { passive: true });
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.goTo(self.page - 1);
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.goTo(self.page + 1);
        });
      }
      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.goTo(parseInt(dot.getAttribute('data-page') || '0', 10));
        });
      });
    };

    function initSection(section) {
      if (section.dataset.cdiInit) return;
      section.dataset.cdiInit = '1';
      var tabs      = section.querySelectorAll('.cdi-home-products__tab');
      var panels    = section.querySelectorAll('.cdi-home-products__panel');
      var carousels = {};

      panels.forEach(function (panel) {
        var id = panel.id;
        if (panel.querySelector('.cdi-home-products__track')) {
          carousels[id] = new PanelCarousel(panel);
        }
      });

      var tabsEl    = section.querySelector('.cdi-home-products__tabs');
      var indicator = document.createElement('span');
      indicator.className = 'cdi-home-products__tabs-indicator';
      indicator.setAttribute('aria-hidden', 'true');
      tabsEl.appendChild(indicator);

      function syncIndicator(activeTab) {
        var range = document.createRange();
        range.selectNodeContents(activeTab);
        var textWidth = range.getBoundingClientRect().width;
        indicator.style.left  = activeTab.offsetLeft + 'px';
        indicator.style.width = textWidth + 'px';
      }

      requestAnimationFrame(function () {
        var firstActive = section.querySelector('.cdi-home-products__tab.is-active');
        if (firstActive) {
          indicator.style.transition = 'none';
          syncIndicator(firstActive);
          requestAnimationFrame(function () { indicator.style.transition = ''; });
        }
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('aria-controls');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          syncIndicator(tab);

          var targetPanel = document.getElementById(targetId);
          if (targetPanel) {
            targetPanel.classList.add('is-active');
            targetPanel.removeAttribute('hidden');
            if (carousels[targetId]) {
              carousels[targetId].reset();
            }
          }
        });
      });

      panels.forEach(function (panel) {
        if (!panel.hasAttribute('hidden') && carousels[panel.id]) {
          carousels[panel.id]._syncUI();
        }
      });
    }

    document.querySelectorAll('.cdi-home-products').forEach(initSection);

  })();
